import React from "react";
import { SectionsUIProvider } from "./SectionsUIContext";
import { SectionsCard } from "./SectionsCard";

export function SectionsPage({
  setReceipentIds
}) {
  return (
    <SectionsUIProvider>
      <SectionsCard 
        setReceipentIds={setReceipentIds}
      />
    </SectionsUIProvider>
 );
}